"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageTypeStringValue = void 0;
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
// in some cases, we get the pageType as a number rather than the literal string/enum -
// let's always check this to avoid errors
/**
 *
 */
function getPageTypeStringValue(pageType) {
    if (typeof pageType === "number") {
        const pageTypeValue = web_blizzard_reporting_1.PageType[pageType];
        return pageTypeValue ? pageTypeValue.toString() : web_blizzard_reporting_1.PageType.UNSET.toString();
    }
    // it's the literal enum, we can just return
    if (typeof pageType === "string") {
        return pageType;
    }
    return web_blizzard_reporting_1.PageType.UNSET.toString();
}
exports.getPageTypeStringValue = getPageTypeStringValue;
//# sourceMappingURL=pages.js.map